/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { ToDoItem } from 'client-code/recordings';

import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import { TOfferPreview } from '../../../core/types';
import {
    ON_GO_NEXT_PAGE_TO_DO_LIST,
    ON_GO_PREVIOUS_PAGE_TO_DO_LIST,
    ON_RETRY_FETCH_TO_DO_LIST_WHEN_ERROR,
    ON_SET_CARET_VISIBILITY_TO_DO_LIST,
    ON_SET_CURRENT_PAGE_TO_DO_LIST,
    ON_SET_GHOST_MODE_TO_DO_LIST,
    ON_SET_TO_DO_LIST_API_ERROR,
    ON_SET_TO_DO_LIST_DATA,
    ON_SET_TO_DO_LIST_SELECTED_ROW_PREVIEW,
    ON_SET_TOTAL_COUNT_TO_DO_LIST,
    ON_SET_VERTICAL_POSITION_TO_DO_LIST,
} from './todolist.types';

export const setGhostModeAction = (
    ghostMode: boolean,
): TivoPayloadAction<{ ghostMode: boolean }> => ({
    type: ON_SET_GHOST_MODE_TO_DO_LIST,
    payload: {
        ghostMode,
    },
});

export const setVerticalPositionToDoListAction = (
    index: number,
): TivoPayloadAction<{ verticalPosition: number }> => ({
    type: ON_SET_VERTICAL_POSITION_TO_DO_LIST,
    payload: {
        verticalPosition: index,
    },
});

export const setToDoListDataAction = (
    toDoItems: ToDoItem[],
): TivoPayloadAction<{ toDoItems: ToDoItem[] }> => ({
    type: ON_SET_TO_DO_LIST_DATA,
    payload: {
        toDoItems,
    },
});

export const setCurrentPageToDoListAction = (
    currentPage: number,
): TivoPayloadAction<{ currentPage: number }> => ({
    type: ON_SET_CURRENT_PAGE_TO_DO_LIST,
    payload: {
        currentPage,
    },
});

export const setTotalCountToDoListAction = (
    totalCount: number,
): TivoPayloadAction<{ totalCount: number }> => ({
    type: ON_SET_TOTAL_COUNT_TO_DO_LIST,
    payload: {
        totalCount,
    },
});

export const goToToDoListNextPageAction = () => ({
    type: ON_GO_NEXT_PAGE_TO_DO_LIST,
});

export const goToToDoListPreviousPageAction = (verticalPosition: number) => ({
    type: ON_GO_PREVIOUS_PAGE_TO_DO_LIST,
    payload: {
        verticalPosition,
    },
});

export const onSetToDoListSelectedRowPreviewAction = (
    selectedTodoPreviewPromise: Promise<TOfferPreview> | null,
): TivoPayloadAction<{ selectedTodoPreviewPromise: Promise<TOfferPreview> | null }> => ({
    type: ON_SET_TO_DO_LIST_SELECTED_ROW_PREVIEW,
    payload: {
        selectedTodoPreviewPromise,
    },
});

export const setCaretVisibilityAction = (
    isCaretVisible: boolean,
): TivoPayloadAction<{ isCaretVisible: boolean }> => ({
    type: ON_SET_CARET_VISIBILITY_TO_DO_LIST,
    payload: {
        isCaretVisible,
    },
});

export const setToDoListApiErrorAction = (
    isError: boolean,
): TivoPayloadAction<{ isError: boolean }> => ({
    type: ON_SET_TO_DO_LIST_API_ERROR,
    payload: {
        isError,
    },
});

export const setRetryFetchCounterAction = (
    retryFetchCounter: number,
): TivoPayloadAction<{ retryFetchCounter: number }> => ({
    type: ON_RETRY_FETCH_TO_DO_LIST_WHEN_ERROR,
    payload: {
        retryFetchCounter,
    },
});
